<template>
  <div v-if="hcCaseFlightFiles && hcCaseFlightFiles.length">
    <el-form-item
      class="custom-label__input width25"
      :label="fieldTitle"
      prop="flightFileList"
    >
      <el-row :gutter="24">
        <el-col :span="24">
          <div class="jobInfoAttachment style-fullWidth">
            <div
              v-for="hcCaseFlightFile in hcCaseFlightFiles"
              v-bind:key="hcCaseFlightFile.id"
              class="file-uploaded input-none__border"
            >
              <div class="file clickable flex-row flex__between padding-0">
                <a
                  class="flex-row flex__left margin-left-10"
                  @click="downloadFile(hcCaseFlightFile)"
                >
                  <file-type-image
                    :fileExtention="hcCaseFlightFile.fileExtention"
                    :customClass="''"
                  />
                  <span class="">{{ hcCaseFlightFile.fileName }}</span>
                </a>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </el-form-item>
  </div>
</template>

<script>
import FileTypeImage from "../../job/FileTypeImage";
import handleRequestErrorMixin from "../../handleRequestErrorMixin";
import hcCaseFlightFileService from "../../../services/maybay/hcCaseFlightFileService";
import hanhChinhUtils from "../../../services/hanhChinhUtils";
import downloadService from "../../../services/downloadService";

export default {
  name: "hc-maybay-upload-readonly",
  mixins: [handleRequestErrorMixin],
  components: { FileTypeImage },
  props: ["hcCaseMasterId", "hcCaseFlightFileType", "hcCaseFlightId"],

  data() {
    return {
      hcCaseFlightFiles: [],
      fieldTitle: null,
      hcCaseFlight: null
    };
  },

  watch: {
    hcCaseMasterId() {
      this.reloadData();
    }
  },

  created() {
    this.reloadData();
  },

  methods: {
    initFieldTitle() {
      this.fieldTitle = hanhChinhUtils.initHcCaseFlightFilesFieldTitle(
        this.hcCaseFlightFileType
      );
    },

    loadHcCaseFlightFiles() {
      return hcCaseFlightFileService
        .findAllByHcCaseMasterId(this.hcCaseMasterId, this.hcCaseFlightFileType)
        .then(response => (this.hcCaseFlightFiles = response.data));
    },

    downloadFile(hcCaseFlightFile) {
      downloadService.downloadFileForHcCaseFlightFile(
        this.hcCaseFlightId,
        hcCaseFlightFile.id,
        hcCaseFlightFile.attachmentId
      );
    },

    reloadData() {
      this.loadHcCaseFlightFiles();
      this.initFieldTitle();
    }
  }
};
</script>

<style scoped>
.download-icon:hover {
  color: var(--color-blue) !important;
}
</style>



// WEBPACK FOOTER //
// src/views/adminstration/vemaybay/hc-maybay-upload-readonly.vue